import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import "./avatar.scss";

const variants = ["success", "warning", "danger", "info"];
const sizes = ["sm", "md", "lg"];

const isValidAvatarSize = size => sizes.includes(size);

const Avatar = props => {
  const {
    dataTestId = "orion-avatar",
    label = "",
    variant = "info",
    className,
    size = "md"
  } = props;

  const initials = label
    .toUpperCase()
    .split(" ")
    .slice(0, 2)
    .map(name => name[0])
    .join("");

  const avatarSize = isValidAvatarSize(size) ? size : "md";

  return (
    <div
      data-testid={dataTestId}
      className={cx(
        className,
        "oui-avatar",
        `oui-avatar-variant-${variant}`,
        `oui-avatar-size-${avatarSize}`
      )}
    >
      <span>{initials}</span>
    </div>
  );
};

Avatar.propTypes = {
  label: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(variants),
  size: PropTypes.oneOf(sizes)
};

Avatar.displayName = "OrionAvatar";

export default Avatar;
